<template>
  <v-dialog v-model="show" width="500px">
    <v-card>
      <v-container>
        <v-card-title>
          <v-col cols="12">
            <label>Skill</label>
            <v-autocomplete
              v-model="skillData"
              :items="skillList"
              chips
              filled
              label="choose skills"
              item-text="skill_name"
              color="blue-grey lighten-2"
              item-value="id"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(data.item)"
                >
                  {{ data.item.skill_name }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-card-title>
        <v-card-actions>
          <v-btn rounded color="info" @click="addSkill">Insert</v-btn>
          <v-btn rounded color="secondary" @click="clearSkill">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectSkillAdd",
  props: ["skillList", "skillAdd"],
  data() {
    return {
      skillData: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.skillAdd;
      },
      set(show) {
        this.$emit("update-add-skill-modal", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "CreateProjectSkill",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async addSkill() {
      await this.showLoadingProcess();
      try {
        const value = {
          project_id: this.$route.query.project_id,
          skill_id: this.skillData,
        };
        await this.CreateProjectSkill(value);
        await this.closeLoading();
        this.clearSkill();
        await this.showSnackBar({
          text: "Skills has been added to Project",
          color: DEFAULT_CONSTANTS.success,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        this.clearSkill();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    clearSkill() {
      this.show = false;
      this.skillData = [];
    },
  },
};
</script>

<style scoped></style>
